//
// Utility for building TableWidget input data.
// Converts an array of objects, all with identical keys,
// into the structure used by the TableWidget.
//
class Table {
    //
    // data - array of objects, all with identical keys
    //
    constructor(data) {
        this.__data = data;
    }

    //
    // Generate the TableWidget input
    // columns - optional filter array of keys to display; length must be <= number of keys in data
    // titles  - optional column titles; if specified, length must = columns length
    // return  - data for TableWidet
    // If columns are not provided then data keys are used
    // If titles are not provided then column names (data keys) are used
    //
    build(columns, titles) {
        let table = {
            records: [],
            columns: [],
            header: [],
            rows: [],
        };

        if (!this.__data || this.__data.length === 0) {
            return table;
        }

        // use the first item in the data as exemplar
        let item = this.__data[0];

        if (!columns || columns.length === 0) {
            table.columns = Object.keys(item);
        } else {
            table.columns = columns;
        }

        if (!titles || titles.length === 0) {
            table.header = table.columns;
        } else {
            table.header = titles;
        }

        if (table.columns.length !== table.header.length) {
            throw new Error("Table.build: columns and titles are not the same length");
        }

        if (Object.keys(item).length < table.columns.length) {
            throw new Error("Table.build: too many columns");
        }

        // build rows
        this.__data.forEach(record => {
            let row = []

            for (let column of table.columns) {
                row.push(record[column]);
            }

            row.__record_index = table.records.length;

            table.rows.push(row);
            table.records.push(record);
        });

        return table;
    }
}

export default Table;
